<template>
  <div class="key-points">
    <div v-for="(point, index) in points"
         :key="index"
         class="key-points__item">
      <div class="key-points__item__icon__container">
        <font-awesome-icon :icon="['fas','check']"
                           class="key-points__item__icon">
        </font-awesome-icon>
      </div>
      <p class="key-points__item__content">
        {{ point }}
      </p>
    </div>
  </div>
</template>
<script>

export default {
  name: "KeyPoints",
  props: {
    points: {
      type: Array,
      default: () => ( [] ),
    },
  },
};
</script>

<style lang="less" scoped>
  @import "../../Styles/utils/index.less";

  .key-points {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    margin: 0 0 28px;

    &{}

    &__item {
      display: flex;
      flex: 0 0 48%;

      @media ( max-width: @lg ) {
        flex: 1 0 48%;
      }

      &{}

      &__content {
        padding: 0;
      }

      &__icon {
        color: @mastered;
        transform: scale(1);

        &{}

        &__container {
          margin: 0 10px 0 0;
        }
      }
    }
  }
</style>
